module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-8-c7307f574820a18b79483cb146bb76d8.jpg";